export default class AbortOptimistic extends Error {}
